export default __webpack_public_path__ + "static/media/SN.a2ebe889.svg";